<template>
  <div v-if="hasAccessToPage">
    <v-app-bar elevation="0" color="lightPrimary" class="light-grey-border-bottom">
      <v-container fluid class="align-center">
        <v-row justify="start" class="mx-4">
          <v-col class="d-flex" cols="12" lg="12" xl="11">
            <LabLocationSelector @locationChanged="getCalendarEntries" />
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>
    <v-container class="intake-form-page" fluid>
      <v-row justify="start" class="mx-4">
        <v-col cols="12" lg="12" xl="11">
          <v-card class="elevation-2 card-empty" color="primary">
            <!-- CALENDAR BODY -->
            <v-card-text class="bg-white text-area pa-0">
              <AppoinmentsCalendar :user="user" @getCalendarEntriesParent="getCalendarEntries" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- / -->
    </v-container>
  </div>
  <NoAccessMessage v-else />
</template>

<script>
import SharedFunctions from '@/mixins/SharedFunctions.vue';
import NoAccessMessage from '@/components/generic/no-access-message.vue';
import AppoinmentsCalendar from '@/views/AppointmentsCalendarPage/components/appoinments-calendar.vue';
import { mapGetters } from 'vuex';
import LabLocationSelector from '@/views/AppointmentsCalendarPage/components/lab-location-selector.vue';

export default {
  mixins: [SharedFunctions],
  components: {
    NoAccessMessage,
    AppoinmentsCalendar,
    LabLocationSelector
  },
  computed: {
    ...mapGetters({
      currentCalendarRange: 'appointmentsCalendarStore/currentCalendarRange'
    }),
    locationSelected() {
      return this.$store.state.appointmentsCalendarStore.locationSelected;
    }
  },
  data() {
    return {
      hasAccessToPage: false
    };
  },
  created() {
    this.hasAccessToPage = this.hasAccessToPageMixin();
  },
  methods: {
    async getCalendarEntries() {
      let event;
      if (this.currentCalendarRange) {
        event = this.currentCalendarRange;
      } else {
        return null;
      }

      this.$store.commit('appointmentsCalendarStore/SET_CURRENT_CALENDAR_LOADER', true);
      this.$store
        .dispatch('appointmentsCalendarStore/getCalendarEntries', {
          minDate: event.start.date,
          maxDate: event.end.date,
          locationId: this.locationSelected?.id ? this.locationSelected.id : 1
        })
        .then((data) => {
          this.$store.commit('appointmentsCalendarStore/SET_CURRENT_CALENDAR_LOADER', false);
          let events = [];
          const eventsAvailable = this.createCalendarEventsArray(data, 'AVAILABLE_COUNT', 'slots open', 'success');
          const eventsResevedApp = this.createCalendarEventsArray(data, 'RESERVED_APP_COUNT', 'slots reserved app', 'primary');
          const eventsResevedDashboard = this.createCalendarEventsArray(data, 'RESERVED_DASHBOARD_COUNT', 'slots reserved dashboard', 'secondary');

          if (eventsAvailable.length > 0) events = events.concat(eventsAvailable);
          if (eventsResevedApp.length > 0) events = events.concat(eventsResevedApp);
          if (eventsResevedDashboard.length > 0) events = events.concat(eventsResevedDashboard);

          this.$store.commit('appointmentsCalendarStore/SET_CURRENT_CALENDAR_EVENTS', events);
        });
    },
    createCalendarEventsArray(data, type, text, color) {
      let events = data
        //filters all event types that have a zero count
        .filter((event) => {
          return event[type] > 0;
        })
        .map((event) => {
          return {
            name: event[type] + ' ' + text,
            start: event.date,
            color: color
          };
        });

      return events;
    }
  }
};
</script>
